import { useContext } from "react";
import { LuBookOpen, LuArrowRight } from "react-icons/lu";
import { OwnerGuideContext as GuideContext } from "./context";
import { guideSteps } from "./content";
import "./style.css";
export const OwnerGuideEntry = ({ compact = false }) => {
  const guide = useContext(GuideContext);
  if (!guide || (!guide.record?.eligible && !guide.error)) return null;
  return (
    <section
      className={`ownerGuideEntry ${compact ? "ownerGuideEntryCompact" : ""}`}
    >
      <span className="ownerGuideEntryIcon">
        <LuBookOpen aria-hidden="true" />
      </span>
      <div>
        <h2>
          {guide.record?.status === "completed"
            ? "Tu guía de Delibrán"
            : "Primeros pasos con Delibrán"}
        </h2>
        <p>
          {guide.error ||
            (guide.record?.status === "completed"
              ? "Repasa las herramientas del Admin cuando lo necesites."
              : `Conoce la plataforma y prepara tu negocio a tu ritmo. Guía: ${guide.record?.step + 1} de ${guideSteps.length}.`)}
        </p>
      </div>
      <button type="button" disabled={guide.loading} onClick={guide.openGuide}>
        {guide.loading
          ? "Cargando…"
          : guide.error
            ? "Reintentar guía"
            : guide.record?.status === "completed"
              ? "Volver a ver la guía"
              : "Retomar guía"}
        <LuArrowRight aria-hidden="true" />
      </button>
    </section>
  );
};
